// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"293":"92c6459a","787":"923fdd06"}[chunkId] + ".chunk.js";
};